var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoRedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "noun_Info_2394143 (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 380",
    cx: 0.556,
    cy: 0.556,
    transform: "translate(3.444 1.818)",
    style: {
      fill: "#e32a34"
    },
    r: 0.556
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2366",
    d: "M199.924 193.582v1.831a.462.462 0 0 1-.924 0v-1.831a.462.462 0 0 1 .924 0z",
    transform: "translate(-195.462 -189.687)",
    style: {
      fill: "#e32a34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2367",
    d: "M4 0a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm2.326 6.326a3.289 3.289 0 1 1 0-4.651 3.289 3.289 0 0 1 0 4.651z",
    style: {
      fill: "#e32a34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2368",
    d: "M4 0a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm2.326 6.326a3.289 3.289 0 1 1 0-4.651 3.289 3.289 0 0 1 0 4.651z",
    style: {
      fill: "#e32a34"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRedIcon);
export default __webpack_public_path__ + "static/media/InfoRedIcon.fbd9ccf6725d866c58dffe745e8f6578.svg";
export { ForwardRef as ReactComponent };